import type React from "react";
import type { SniCode } from "../../types";
import { Stack } from "../stack";
import { SniCodeItem } from "./sni-code-item";

type Props = {
	allCodes: Array<SniCode>;
	selectedCodes: Array<string>;
	onDeleteClick: (arg: string) => void;
};

const getDescription = (allCodes: Array<SniCode>, code: string) =>
	allCodes.find((c) => c.sniCode === code)?.description || "";

export const SelectedSniCodes: React.FC<Props> = ({ allCodes, selectedCodes, onDeleteClick }) => {
	if (selectedCodes.length < 1) return null;
	return (
		<Stack gap={4} direction="row" wrap>
			{selectedCodes.map((c) => (
				<SniCodeItem
					key={c}
					description={getDescription(allCodes, c)}
					sniCode={c}
					onDelete={onDeleteClick}
				/>
			))}
		</Stack>
	);
};
